import * as React from "react";
import { cn } from "../lib/utils.js";

/**
 * Page or step heading that takes focus (CAP-10): on route change focus moves
 * to the page `h1`, on a step change inside a flow to the step heading.
 * `focusKey` changes → the heading is focused again.
 */
export interface FocusHeadingProps extends React.ComponentProps<"h1"> {
  as?: "h1" | "h2";
  /** Focus when mounted / when this key changes. Omit to never auto-focus. */
  focusKey?: string | number;
}

function FocusHeading({ as = "h1", focusKey, className, ...props }: FocusHeadingProps) {
  const ref = React.useRef<HTMLHeadingElement>(null);
  React.useEffect(() => {
    if (focusKey !== undefined) ref.current?.focus({ preventScroll: false });
  }, [focusKey]);
  const Tag = as;
  return (
    <Tag
      ref={ref}
      tabIndex={-1}
      data-slot="focus-heading"
      className={cn("font-display text-2xl font-bold", className)}
      {...props}
    />
  );
}

export { FocusHeading };
